import curry from 'lodash/curry';
import { pluck } from './objects';

export const isArray = Array.isArray;

export const slice = curry((start, end, array) => {
	if (!array) {
		return [];
	}
	return array.slice(start, end);
});

export const takeFirst = slice(0);

export const prepend = (element, array) => (array ? [ element ].concat(array) : [ element ]);

export const concat = (element, array) => (array ? array.concat(element) : [ element ]);

export const head = (arr) => arr && arr[0];

export const filter = (predicate) => (array) => array.filter(predicate);

export const arrayToSet = (array) => new Set(array);

export const hasMinLength = (minLength) => (array) => array && array.length >= minLength;

export const any = (predicate) => (array) => isArray(array) && array.some(predicate);

export const joinProp = (prop, delimeter) => (array) => {
	if (isArray(array)) {
		const propValue = pluck(prop);
		return array.reduce((acc, val, index) => `${acc}${index === 0 ? '' : delimeter}${propValue(val)}`, '');
	}
};

export const normalize = (id) => (arr) =>
	arr.reduce(
		(acc, val = {}) => ({
			...acc,
			[val[id]]: val
		}),
		{}
	);
